import * as React from 'react';
import { CompleteAccessProps } from '../types';

const CompleteAccess: React.FC<CompleteAccessProps> = () => {
  const [showAnimation, setShowAnimation] = React.useState<boolean>(false);
  const [userInfo, setUserInfo] = React.useState<any>(null);
  
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(true);
    }, 300);
    
    const storedUserInfo = localStorage.getItem('userInfo');
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        setUserInfo(parsedUserInfo);
        //console.log("User info loaded from localStorage:", parsedUserInfo);
      } catch (error) {
        //console.error("Error parsing user info:", error);
      }
    } else {
      console.log("No user info found in localStorage");
    }
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="step-content">
      <h2>KCNSC O365 Access Granted!</h2>
      <div className={`success-icon ${showAnimation ? 'animate-success' : ''}`}>✓</div>
      <p>Your KCNSC O365 External Access has been successfully configured</p>
      <p className="success-description">You can now access the shared resources in O365</p>
      
      {userInfo ? (
        <div className="user-info-container">
          <h3>User Information</h3>
          <div className="user-info-card">
            <div className="user-info-header">
              <div className="user-avatar">{userInfo.name ? userInfo.name.substring(0, 2).toUpperCase() : 'U'}</div>
              <div className="user-name-email">
                <h4>{userInfo.name || 'User'}</h4>
                <p>{userInfo.email || userInfo.username || 'No email available'}</p>
              </div>
            </div>
            
            <div className="user-info-details">
              <div className="detail-row">
                <span className="detail-label">Full Name:</span>
                <span className="detail-value">{userInfo.name || 'Not available'}</span>
              </div>
              
              {userInfo.givenName && (
                <div className="detail-row">
                  <span className="detail-label">First Name:</span>
                  <span className="detail-value">{userInfo.givenName}</span>
                </div>
              )}
              
              {userInfo.familyName && (
                <div className="detail-row">
                  <span className="detail-label">Last Name:</span>
                  <span className="detail-value">{userInfo.familyName}</span>
                </div>
              )}
              
              <div className="detail-row">
                <span className="detail-label">Email:</span>
                <span className="detail-value">{userInfo.email || userInfo.username || 'Not available'}</span>
              </div>
              
              {userInfo.jobTitle && (
                <div className="detail-row">
                  <span className="detail-label">Job Title:</span>
                  <span className="detail-value">{userInfo.jobTitle}</span>
                </div>
              )}
              
              {userInfo.department && (
                <div className="detail-row">
                  <span className="detail-label">Department:</span>
                  <span className="detail-value">{userInfo.department}</span>
                </div>
              )}
              
              <div className="detail-row">
                <span className="detail-label">Login Time:</span>
                <span className="detail-value">
                  {localStorage.getItem('loginTimestamp') 
                    ? new Date(localStorage.getItem('loginTimestamp') || '').toLocaleString() 
                    : 'Not available'}
                </span>
              </div>
              
              <div className="detail-row">
                <span className="detail-label">Tenant ID:</span>
                <span className="detail-value detail-id">{userInfo.tenantId || 'Not available'}</span>
              </div>
              
              <div className="detail-row">
                <span className="detail-label">Object ID:</span>
                <span className="detail-value detail-id">{userInfo.objectId || 'Not available'}</span>
              </div>
            </div>
          </div>
          
          <div className="token-info">
            <details>
              <summary>Access Token Information</summary>
              <p>Access token is available and stored locally. This token can be used to access SharePoint resources.</p>
              <p>Token was acquired at: {localStorage.getItem('loginTimestamp') 
                ? new Date(localStorage.getItem('loginTimestamp') || '').toLocaleString()
                : 'Unknown time'}</p>
            </details>
          </div>
        </div>
      ) : (
        <div className="no-user-info">
          <p>No user information found in storage. This might happen if:</p>
          <ul>
            <li>The login process did not complete successfully</li>
            <li>The browser storage was cleared</li>
            <li>There were permission issues with storing user data</li>
          </ul>
          <p>You can try logging out and logging in again.</p>
        </div>
      )}
      
      <div className="storage-view">
        <details>
          <summary>View Storage Data</summary>
          <div className="storage-data">
            <h4>LocalStorage Data:</h4>
            <pre>{Object.keys(localStorage).map(key => `${key}: ${localStorage.getItem(key)?.substring(0, 50)}${localStorage.getItem(key)?.length || 0 > 50 ? '...' : ''}`).join('\n')}</pre>
            
            <h4>SessionStorage Data:</h4>
            <pre>{Object.keys(sessionStorage).map(key => `${key}: ${sessionStorage.getItem(key)?.substring(0, 50)}${sessionStorage.getItem(key)?.length || 0 > 50 ? '...' : ''}`).join('\n')}</pre>
          </div>
        </details>
      </div>
    </div>
  );
};

export default CompleteAccess;